import { useState } from 'react';

import { useAuth } from './AuthContext';
import { PinRateLimitError } from './authErrors';
import { PinPad } from './PinPad';
import './auth.css';

export function IdleLockOverlay() {
  const { locked, user, unlockWithPin } = useAuth();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  if (!locked || !user) return null;

  const unlock = async (pin: string) => {
    setBusy(true);
    setError(null);
    try {
      await unlockWithPin(pin);
    } catch (caught: unknown) {
      setError(
        caught instanceof PinRateLimitError
          ? caught.message
          : 'Odklep ni uspel. Preverite PIN in poskusite znova.',
      );
      throw new Error('PIN unlock failed', { cause: caught });
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      className="lock-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="lock-title"
    >
      <section className="auth-card lock-card">
        <h1 id="lock-title">Pozdravljeni, {user.displayName}</h1>
        <PinPad busy={busy} error={error} onSubmit={unlock} />
      </section>
    </div>
  );
}
